/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
$(() => {
  const $pageWrapper = $('.hand-arm-vibration');

  if ($pageWrapper.length === 0) {
    return;
  }

  const $accordionHeadings = $pageWrapper.find('.js-accordion-title');
  $accordionHeadings.click(function () {
    const $this = $(this);
    const $accordionItem = $this.closest('.js-accordion-item');

    if ($accordionItem.hasClass('js-accordion-closed')) {
      closeAllAccordions();
      $accordionItem.removeClass('js-accordion-closed');
      $accordionItem.removeClass('hav__accordion__item--closed');

      $accordionItem.addClass('js-accordion-open');
      $accordionItem.addClass('hav__accordion__item--open');

      $accordionItem.find('.js-accordion-drop').slideDown();
    } else if ($accordionItem.hasClass('js-accordion-open')) {
      $accordionItem.removeClass('js-accordion-open');
      $accordionItem.removeClass('hav__accordion__item--open');

      $accordionItem.addClass('js-accordion-closed');
      $accordionItem.addClass('hav__accordion__item--closed');

      $accordionItem.find('.js-accordion-drop').slideUp();
    }
  });

  function closeAllAccordions() {
    $('.js-accordion-drop').slideUp();
    const $allAccordions = $('.js-accordion-item');

    $allAccordions.removeClass('js-accordion-open');
    $allAccordions.removeClass('hav__accordion__item--open');

    $allAccordions.addClass('js-accordion-closed');
    $allAccordions.addClass('hav__accordion__item--closed');
  }
});
